export enum TargetPropertyRadioButtonValues {
    No = 'NO',
    Yes = 'YES',
}
